import { LinkOutlined } from '@ant-design/icons';
import { Button } from '@g2u/ui-kit';
import { type ChatActionHandler } from './types';

export const ViewUrlAction: ChatActionHandler = {
  type: 'VIEW_URL',
  render: (payload) => {
    if (!payload?.url) return null;
    return (
      <Button.$
        dataTestId="ai-action-view-url"
        type={Button.Type.Primary}
        size={Button.Size.Small}
        icon={<LinkOutlined />}
        href={payload.url}
        target="_blank"
      >
        Open Guide
      </Button.$>
    );
  },
};
